<template>
	<div class="footerbox" v-if="this.$route.name!='Giftlist'&&this.$route.name!='Lottery'&&this.$route.name!='Winnerlist'&&this.$route.name!='Lotterytest'&&this.$route.name!='AvatarWall'&&this.$route.name!='Error'">
    <div class="footerinfo">
      <div class="uslist mt-25 f-14">
        本站由 阿里云 提供计算与安全服务   丨  举报邮箱：kefu@motortime.com
      </div>
      <div class="uslist mt-10 f-14 mb-50">
        ®2015-{{newYear}} 北京御城铭翼网络科技有限公司 | 
        <a target="_blank" href="https://beian.miit.gov.cn">京ICP备15065994号-1</a>
        | 京ICP证B2-20181209号
      </div>
    </div>
  </div>
</template>
<script>
	export default{
    data (){
      return{
        newYear:2023,
      }
    },
    created (){
      this.newYear=new Date().getFullYear()
    }
  }
</script>
<style lang="scss">
	
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue